var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeploySwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.88657,
    height: 134.88657,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 134.88657 134.88657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.676,
    y1: 439.96537,
    x2: 77.05851,
    y2: 423.51746,
    gradientTransform: "translate(0 499.1847) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4249.6749,
    y1: 1010.86818,
    x2: -4188.29245,
    y2: 1027.31652,
    gradientTransform: "translate(1086.53563 -4130.46437) rotate(-90) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 134.88657,
    height: 134.88657,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "z4ifqssmhc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.78617,114.33744l13.73314-10.98483v-31.69835c0-1.11703.44259-2.19191,1.23505-2.98015l17.1601-17.1601c7.13626-7.10006,11.13702-16.75896,11.11129-26.82556v-7.83185h-7.82764c-10.06706-.02809-19.72684,3.97304-26.82557,11.11128l-17.1601,17.1601c-.78953.79174-1.86202,1.23621-2.98015,1.23506h-31.69834l-10.98061,13.73314,51.70792,7.38504-1.1929,8.34189-59.01287-8.43041c-2.30485-.32748-3.90782-2.4614-3.58034-4.76625.10616-.74718.41097-1.45215.88261-2.04131l16.86082-21.07603c.80089-.99901,2.01487-1.5807,3.29208-1.5807h31.97655l15.92505-15.92505c8.6754-8.7253,20.48171-13.61601,32.78587-13.58139h7.82763c4.64937,0,8.43041,3.78104,8.43041,8.43041v7.83185c0,12.38427-4.82641,24.02667-13.58139,32.78586l-15.92505,15.92505v31.97655c.00048,1.28049-.58112,2.49177-1.5807,3.29208l-21.07603,16.86082c-1.82586,1.45172-4.48286,1.14841-5.93458-.67745-.46374-.58325-.76492-1.27881-.87298-2.01607l-8.42619-59.01287,8.34189-1.1929,7.38504,51.70792v.00421Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.86082,54.79767h59.01287v25.29123H16.86082v-25.29123Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.79767,118.02575v-59.01287h25.29123v59.01287h-25.29123Z",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 67.44328,
    x2: 134.88657,
    y2: 67.44328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.31083,
    y1: 88.51931,
    x2: 70.42368,
    y2: 88.51931,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 30.74149,
    y1: 118.04472,
    x2: 53.66377,
    y2: 118.04472,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.29029,
    y1: 92.77965,
    x2: 32.56871,
    y2: 92.77965,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deploy_White"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h134.88657v134.88657H0V0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.31083,106.61453l42.15165-42.15165,5.9612,5.9612-42.15165,42.15165-5.9612-5.9612Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.70179,129.45738l-5.9603-5.9603,16.96198-16.86503,5.9603,5.9603-16.96198,16.86503Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29029,102.45766l25.31722-25.31722,5.9612,5.9612-25.31722,25.31722-5.9612-5.9612Z",
    fill: "url(#linear-gradient-6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploySwitcher);
export default __webpack_public_path__ + "static/media/deploy_switcher.2770d10711b0d004a747c4e87fba220f.svg";
export { ForwardRef as ReactComponent };